import * as E from './element';

export const DiscountedPrice = ({ currency, ticket, ticketOverrides, quantity }) => {
  const priceBase = ticket.get('pay_what_you_want') ? ticketOverrides[+ticket.get('id')] || 0 : ticket.get('price');
  const price = priceBase * quantity;
  const priceNum = Math.max(0, +price);
  return (
    <E.Wrapper>
      {currency}
      {priceNum.toFixed(2)}
    </E.Wrapper>
  );
};
